import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { pdfjs } from 'react-pdf';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ReportHeader from './ReportDetailHeader';
import ReportInfo from './ReportInfo';
import PDFViewer from './PDFviewer';
import useDetectCurrentPage from './hook/useDetectCurrentPage';
import { transformReport } from '../../lib/reportTools';
import { PAGE_PATH, REPORT_STATUS } from '../../lib/constants';
import { ReportStatus } from '../ReportEdit/TitleArea';
import UserPrompt from '../UserPrompt';

// TODO: ビルド時にpublicディレクトリに対象ファイルにコピーすること
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.js';

const options = {
  cMapUrl: '/cmaps/',
  standardFontDataUrl: '/standard_fonts/',
};

const Main = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 15px;
`;

const PDFContainer = styled.div`
  display: flex;
  overflow: auto;
`;

/**
 * 報告書の詳細を表示するページを表示するコンポーネント
 *
 * - 報告書はPDFとして表示
 * - 報告書の詳細情報（例: 報告書No、件名、最終更新日など）を表示する
 *
 * 内部的には、`PDFViewer` コンポーネントを使用してPDFを表示し、`ReportInfo` コンポーネントを使用して報告書の詳細情報を表示する
 * @returns {ReactElement}
 */
const ReportDetailPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const reportDetail = useSelector(state => state.report.reportDetail);
  const previewFileUrl = useSelector(state => state.report.previewFileUrl);
  const goBack = () => {
    if (reportDetail.status === ReportStatus.complete) {
      dispatch({ type: 'RESET_REPORT_DETAILS' });
      history.push(PAGE_PATH.DS_REPORT);
    } else {
      history.push(`${PAGE_PATH.DS_REPORT_EDIT}/${reportDetail.id}`);
    }
  };
  const transformedReport = transformReport(reportDetail);

  const [pdfFileUrl, setPdfFileUrl] = useState('');
  // TODO: トラッキング目的のため、あとでリファクタリング
  useEffect(() => {
    // fileUrlが上手く更新されない時があるため、reportDetailの変更を監視して更新
    const url =
      (reportDetail.status === ReportStatus.complete && reportDetail.fileUrl) ||
      previewFileUrl;
    setPdfFileUrl(url);
  }, [dispatch, reportDetail, previewFileUrl]);

  const [totalPages, setTotalPages] = useState(null);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setTotalPages(numPages);
  };

  const { currentPage, documentRef, pageRefs } = useDetectCurrentPage();

  const reportUrl =
    reportDetail.status === REPORT_STATUS.CREATE ||
    reportDetail.status === REPORT_STATUS.PUBLISHED
      ? previewFileUrl
      : reportDetail.fileUrl;

  return (
    <Main className="mainPage">
      <UserPrompt />
      <ReportHeader onBack={goBack} />
      <PDFContainer>
        <PDFViewer
          file={pdfFileUrl}
          hasError={reportDetail.hasErrorPreview ?? false}
          totalPages={totalPages}
          onLoadSuccess={onDocumentLoadSuccess}
          options={options}
          documentRef={documentRef}
          pageRefs={pageRefs}
        />
        <ReportInfo
          totalPages={totalPages}
          currentPage={currentPage}
          report={transformedReport}
          reportUrl={reportUrl}
        />
      </PDFContainer>
    </Main>
  );
};

export default ReportDetailPage;
